import { useNode } from '@craftjs/core';
import { Box } from '@mui/material';

import { Markdown } from '@/components/Markdown/Markdown';
import { TextEditorProvider } from '@/components/TextEditor/contexts/TextEditor.provider';
import { EducationalSlideBody } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/components/EducationalSlide.components';

import { useIsBlockEditorEditMode } from '../../BlockEditor.context';
import { BLOCK_DISPLAY_NAMES } from '../../blockEditor.types';
import { EditableComponentWrapper } from '../../EditableComponentWrapper/EditableComponentWrapper';
import { EducationalSlideBodySettings } from './EducationalSlideBodySettings';

export interface EditableEducationalSlideBodyProps {
  text: string;
}

export function EditableEducationalSlideBody({
  text,
}: EditableEducationalSlideBodyProps) {
  const {
    connectors: { connect, drag },
  } = useNode();
  const isEditMode = useIsBlockEditorEditMode();

  return (
    <EditableComponentWrapper>
      <Box
        ref={(ref: HTMLDivElement | null) => {
          if (ref && isEditMode) {
            connect(drag(ref));
          }
        }}
      >
        <TextEditorProvider theme="presentationContent">
          <Markdown markdown={text} EditorInner={EducationalSlideBody} />
        </TextEditorProvider>
      </Box>
    </EditableComponentWrapper>
  );
}

EditableEducationalSlideBody.craft = {
  displayName: BLOCK_DISPLAY_NAMES.EditableEducationalSlideBody,
  props: {
    text: 'Body text content',
  },
  related: {
    settings: EducationalSlideBodySettings,
  },
};
